export default {"src":"/_next/static/media/mousqueton.c3bf978b.svg","height":685,"width":685,"blurWidth":0,"blurHeight":0};